/* requires:
polyfill.js
*/

const jobsApiUrl = 'https://certus.recruitee.com/api/offers/';
const jobsWrapper = document.querySelector('.careers-wrap');
let jobCards = '';

const jobHtml = (job) => {
  const { title, tags, careers_url, state_code, city, country } = job;
  const location = tags.includes('Fully Remote')
    ? `Remote / ${country}`
    : tags.includes('Remote')
    ? `Remote / ${city}, ${state_code}, ${country}`
    : `Onsite / ${city}, ${state_code}, ${country}`;

  return `<div class="col-md-6 d-flex text-theme-primary mb-3 mb-md-4">
            <div class="job-card bg-white rounded-3 shadow-sm w-100 p-4">
              <h3 class="h4 fw-600">${title}</h3>
              <p class="mb-4">${location}</p>
              <p class="mb-0"><a class="cta-btn blue small outline pill w-auto px-4" href="${careers_url}" target="_blank" aria-label="link opens in new tab">View Job</a></p>
            </div>
          </div>`;
};

fetch(jobsApiUrl)
  .then(checkFetchStatus)
  .then((data) => {
    const offers = data.offers;
    if (offers.length) {
      for (let offer of offers) {
        if (offer.category_code !== 'other') {
          jobCards = jobCards + jobHtml(offer);
        }
      }
      jobsWrapper.innerHTML = jobCards;
    } else {
      document.querySelector('#available-jobs').remove();
      // jobsWrapper.innerHTML = '<h3 class="h4 text-center fw-500 mb-5">There\'s currently no job opening.</h3>';
    }
  })
  .catch(function (err) {
    console.error(err);
  });
